export const DEFAULT_LABELS = {
  title: 'Комментарии',
  modalTitle: 'Комментарии',
  noComments: 'Комментариев нет',
  addButton: 'Добавить комментарий',
  showAllButton: (count) => `Показать все комментарии (${count})`,
  newCommentTitle: 'Новый комментарий',
  newCommentPlaceholder: 'Введите комментарий...',
  editingTitle: 'Редактирование комментария',
  charsSuffix: 'символов',
  send: 'Отправить',
  save: 'Сохранить изменения',
  cancelEdit: 'Отменить редактирование',
  edit: 'Редактировать',
  delete: 'Удалить',
  deleteConfirm: 'Удалить этот комментарий?',
  attach: 'Прикрепить файл',
  download: 'Скачать',
  noName: 'Без имени',
  close: 'Закрыть',
  loading: 'Загрузка...',
  sending: 'Отправка...',
  genericError: 'Что-то пошло не так. Попробуйте ещё раз.',
  attachmentsLimitReached: (max) => `Можно прикрепить не более ${max} файлов`,
};

export const DEFAULT_PREVIEW_COUNT = 3;
export const DEFAULT_MAX_LENGTH = 1024;
